export const TimeLineData = [
  {
    id: 1,
    title: "1983",
    data: [
      { month: "Febrero",
        detail: "Llamado a elecciones",
      },
      { month: "Marzo",
        detail:
          "Se crea la Multisectorial de la Mujer, espacio integrado por agrupaciones de mujeres, feministas y representantes de partidos políticos.",
      },
      { month: "Septiembre",
        detail:
          "“siluetazo” en Plaza de Mayo. Relevancia del movimiento de Derechos Humanos. ",
      },
      { month: "",
        detail:
          "El presidente Bignone promulga la ley de Autoamnistía para los miembros de las FF.AA. por los crímenes cometidos durante el régimen militar.",
      },
      { month: "",
        detail:
          "Se estrenó La República Perdida, documental que narra la historia argentina entre 1910 y 1976. Dos millones de espectadores concurrieron a los cines en cuatro meses.",
      },
      { month: "Octubre",
        detail: "Elecciones democráticas",
      },
      { month: "Noviembre",
        detail:
          "“Clics modernos” (Charly García), disco que incluye la canción Dinosaurios.",
      },
      { month: "Diciembre",
        detail: "Asunción de Raúl Alfonsín. 10 de diciembre (1983-1989)",
      },
      { month: "",
        detail:
          "Inicio del proceso de normalización de las Universidades Nacionales. (13/12)",
      },
      { month: "",
        detail: "Creación de la CONADEP",
      },
      { month: "",
        detail:
          "El Congreso Nacional deroga por inconstitucional la ley de Autoamnistía promulgada por el presidente Bignone.",
      },
    ],
  },
  {
    id: 2,
    title: "1984",
    data: [
      {
        month: "Septiembre",
        detail: "Se publica el Informe CONADEP: Nunca Más.",
      },
      {
        month: "Octubre",
        detail:
          "Premio Nobel de Fisiología o Medicina a César Milstein por sus estudios sobre anticuerpos monoclonales.",
      },
      {
        month: "Noviembre",
        detail: "Plebiscito no vinculante para que se avale o no la firma del Tratado de Paz y Amistad que surgió de la Mediación Papal para dar fin al Conflicto por el Canal de Beagle. El 82% de los votantes se manifestaron a favor el 16 % se pronunció en contra y hubo un 2 % de votos nulos.",
      },
      {
        month: "Diciembre",
        detail: "Se aplica el “Índice de abuelidad”, el que establece la posibilidad de parentesco entre un nieto y sus abuelos a partir del análisis del material genético. La primera restitución de identidad que incorporó el análisis como prueba fue en 1984​, el caso de la nieta recuperada Paula Eva Logares.",
      },
    ],
  },
  {
    id: 3,
    title: "1985",
    data: [
      {
        month: "Abril",
        detail: "Inicio del juicio a las Juntas Militares. La Sentencia se produce en diciembre.",
      },
      {
        month: "Junio",
        detail:
          "Se implementa el Plan Austral",
      },
      {
        month: "Septiembre",
        detail: "Patria potestad compartida e igualdad de derechos para los hijos e hijas extra-matrimoniales (Ley 23267)",
      },
      {
        month: "Noviembre",
        detail: "Elecciones legislativas.",
      },
      {
        month: "Diciembre",
        detail: "Alfonsín pronuncia el Discurso de Parque Norte.",
      },
      {
        month: "",
        detail: "Se crea el Consejo Para la Consolidación de la Democracia (coordinado por Carlos Nino)",
      },
    ],
  },
  {
    id: 4,
    title: "1986",
    data: [
      {
        month: "Marzo (24/03)",
        detail: "La película “La historia oficial” obtiene el Oscar a la mejor película de habla no inglesa.",
      },
      {
        month: "Abril",
        detail: "Acto de lanzamiento del II Congreso Pedagógico Nacional (la Asamblea Pedagógica Nacional se realizó en febrero/marzo de 1988).",
      },
      {
        month: "Mayo (24-25)",
        detail: "Primer Encuentro Nacional de Mujeres, en el Teatro San Martín de la ciudad de Buenos Aires.",
      },
      {
        month: "Junio",
        detail: "Argentina se consagra bi Campeón del Mundial de Fútbol.",
      },
      {
        month: "Noviembre",
        detail: "Los presidentes Alfonsín y Sarney firman el Acta de Foz de Iguazú que sentó las bases de lo que seis años después sería el Mercosur",
      },
      {
        month: "Diciembre",
        detail: " Ley de Punto Final (24/86) derogada 1998",
      },
    ],
  },
  {
    id: 5,
    title: "1987",
    data: [
      {
        month: "Enero",
        detail: "1º de los 13 paros generales CGT que se desarrollarían a lo largo del gobierno de Alfonsín",
      },
      {
        month: "Abril",
        detail: "Visita de Juan Pablo II a Argentina.",
      },
      {
        month: "",
        detail: "1º levantamiento militar “carapintada”.",
      },
      {
        month: "Junio",
        detail: "Se crea el Banco Genético de Datos, un archivo de material genético y muestras biológicas de familiares de personas que han sido secuestradas y desaparecidas durante la última dictadura cívico-militar argentina.",
      },
      {
        month: "",
        detail: "Ley de Obediencia Debida (8/6)  Derogada 12/8 2003) ",
      },
      {
        month: "",
        detail: "Ley de Divorcio Vincular",
      },
      {
        month: "Septiembre",
        detail: "Elecciones Legislativas y de gobernadores. El llamado peronismo renovador gana en la Provincia de Buenos Aires (Antonio Cafiero).",
      },
    ],
  },
  {
    id: 6,
    title: "1988",
    data: [
      {
        month: "Enero",
        detail: "Levantamiento militar de Monte Caseros en Corrientes",
      },
      {
        month: "Agosto",
        detail: "Plan económico llamado Primavera",
      },
      {
        month: "Octubre",
        detail: "Festival de Amnesty International en el estadio de River Plate (las Madres en el escenario junto a Sting y otros cantantes)",
      },
      {
        month: "Diciembre",
        detail: "Levantamiento militar de Villa Martelli en Buenos Aires.",
      },
    ],
  },
  {
    id: 7,
    title: "1989",
    data: [
      {
        month: "Enero",
        detail: "Copamiento del cuartel de la Tablada.",
      },
      {
        month: "Mayo",
        detail: "Elecciones presidenciales.",
      },
      {
        month: "",
        detail: "Saqueos, con focos en diferentes ciudades, en donde Rosario es lugar emblemático.",
      },
      {
        month: "Junio",
        detail: "Asunción anticipada de Menem.",
      },
      {
        month: "Julio",
        detail: "Punto más alto de la hiperinflación (200%).",
      },
      {
        month: "Septiembre",
        detail: "Sanción de la Ley de Emergencia Económica (Ley 23.697).",
      },
      {
        month: "Octubre",
        detail: "Indulto por decreto de jefes militares procesados que no habían sido alcanzados por la Ley de punto final y obediencia debida (excepto Suárez Mason), de los ex miembros de la Junta de Comandantes condenados por delitos cometidos en la conducción de la guerra de Malvinas y líderes e integrantes de los grupos civiles armados.",
      },
      {
        month: "",
        detail: "Declaración Conjunta de Madrid I entre Argentina y el Reino Unido de Gran Bretaña que  manifiesta el deseo de normalizar las relaciones diplomáticas suspendidas desde el Conflicto de Malvinas de 1982 y aplicar la fórmula del “Paraguas de la Soberanía”.",
      },
    ],
  },
  {
    id: 8,
    title: "1990",
    data: [
      {
        month: "Enero",
        detail: "Plan económico “Bonex” Antonio Erman González, Ministro de Economía.",
      },
      {
        month: "Septiembre",
        detail: "Asesinato de María Soledad Morales en Catamarca.",
      },
      {
        month: "",
        detail: "Argentina rompe con su tradición de neutralidad anunciando el envío de tropas de la Armada a la 1º Guerra del Golfo en el marco del cumplimiento de las resoluciones del Consejo de Seguridad de Naciones Unidas que condenan la invasión de Irak a Kuwait.",
      },
      {
        month: "Diciembre",
        detail: "Último levantamiento carapintada encabezado por Mohamed Alí Seineldín.",
      },
      {
        month: "",
        detail: "Indulto a la Junta Militar condenada en el Juicio de 1985, y a militares y civiles con responsabilidades de delitos de lesa humanidad y delitos económicos.",
      },
      {
        month: "",
        detail: "El presidente de EE.UU. George H. W. Bush visita Argentina tras el levantamiento militar.",
      },
    ],
  },
  {
    id: 9,
    title: "1991",
    data: [
      {
        month: "Febrero",
        detail: "Desmantelamiento del Plan Cóndor II (vector misilístico) iniciado por Alfonsín.",
      },
      {
        month: "Abril",
        detail: "Inicio del Programa de convertibilidad económica.",
      },
      {
        month: "Mayo",
        detail: "Se firma el Tratado de Asunción que establece la creación del  Mercosur entre Argentina, Brasil, Uruguay y Paraguay.",
      },
      {
        month: "Septiembre",
        detail: "Argentina anuncia su salida del Grupo de No Alineados.",
      },
      {
        month: "Noviembre",
        detail: "Se sanciona la Ley 24.012 de “cuotas” o “cupo femenino”.",
      },
    ],
  },
  {
    id: 10,
    title: "1992",
    data: [
      {
        month: "Marzo",
        detail: "Atentado a la Embajada de Israel.",
      },
      {
        month: "Noviembre",
        detail: "Fundación de la Central de Trabajadores Argentinos (CTA).",
      },
    ],
  },
  {
    id: 11,
    title: "1993",
    data: [
      {
        month: "Abril",
        detail: "Sanción de la Ley Federal de Educación.",
      },
      {
        month: "",
        detail: "Formación del Frente Grande, a partir de un núcleo de peronistas disidentes liderados por Carlos “Chacho” Álvarez.",
      },
      {
        month: "Octubre",
        detail: "Se aplica la ley de cupo femenino para las candidaturas a diputados nacionales.",
      },
      {
        month: "Noviembre",
        detail: "Pacto de Olivos (Menem y Alfonsín).",
      },
      {
        month: "Diciembre",
        detail: "Estallido Social en Santiago del Estero. La ciudadanía prendió fuego a los tres poderes públicos del Estado.",
      },
    ],
  },
  {
    id: 12,
    title: "1994",
    data: [
      {
        month: "Marzo",
        detail: "Muerte del soldado Omar Carrasco (antecedente de la Eliminación del Servicio Militar Obligatorio).",
      },
      {
        month: "Abril",
        detail: "Elecciones para la Asamblea Constituyente.",
      },
      {
        month: "Mayo",
        detail: "Formación del Movimiento de Trabajadores Argentinos, Escisión de la CGT.",
      },
      {
        month: "Julio",
        detail: "Atentado a la Amia.",
      },
      {
        month: "",
        detail: "Marcha Federal organizada por la Mesa de Enlace Sindical.",
      },
      {
        month: "Agosto",
        detail: "Sanción de la Reforma Constitucional.",
      },
      {
        month: "",
        detail: "Eliminación del Servicio Militar Obligatorio, tras el asesinato del soldado Carrasco.",
      },
      {
        month: "",
        detail: "Formación del FREPASO",
      },
      {
        month: "Diciembre",
        detail: "Se aprueba el Protocolo de Ouro Preto, instrumento que establece la estructura institucional del MERCOSUR y se lo dota de personalidad jurídica internacional.",
      },
    ],
  },
  {
    id: 13,
    title: "1995",
    data: [
      {
        month: "Febrero",
        detail: "Interna abierta en el Frepaso (Fórmula Bordón - Alvarez)",
      },
      {
        month: "Abril",
        detail: "Surgimiento de la agrupación HIJOS.",
      },
      {
        month: "",
        detail: "Autocrítica del Jefe del Ejército, General Martín Balza, por el papel de las FF.AA. en el gobierno militar.",
      },
      {
        month: "Abril - Mayo",
        detail: "protestas de estudiantes y docentes universitarios  contra la Ley de Educación Superior",
      },
      {
        month: "Mayo",
        detail: "Elecciones presidenciales - 1º) Menem - Duhalde (PJ)  2°) Bordón - Alvarez (FREPASO)  3º) Masaccesi - Hernández (UCR).",
      },
      {
        month: "Mayo - Junio",
        detail: "desempleo Récord (18%).",
      },
      {
        month: "Julio",
        detail: "Creación del INADI.",
      },
      {
        month: "Noviembre",
        detail: "Explosión de la Fábrica Militar de Río Tercero. ",
      },
      {
        month: "Diciembre",
        detail: "Se firma el Acuerdo Marco de Cooperación MERCOSUR-UE.",
      },
    ],
  },
  {
    id: 14,
    title: "1996",
    data: [
      {
        month: "Junio",
        detail: "Surgimiento del Movimiento Piquetero (movilizaciones y puebladas de Cutral Có y Plaza Huincul).",
      },
      {
        month: "",
        detail: "Primera elección del Intendente de Capital Federal. Fernando de la Rúa, primer intendente electo.",
      },
      {
        month: "Diciembre",
        detail: "Paro nacional de las centrales sindicales (CGT, MTA, CTA) al gobierno de Menem.",
      },
    ],
  },
  {
    id: 15,
    title: "1997",
    data: [
      {
        month: "Enero",
        detail: "Asesinato del reportero gráfico José Luis Cabezas.",
      },
      {
        month: "Agosto",
        detail: "Conformación de la Alianza por la Justicia, el Trabajo y la Educación (UCR + Frepaso).",
      },
      {
        month: "Diciembre",
        detail: "Comienzo de la protesta docente  denominada “Carpa Blanca”. Culmina en diciembre de 1999.",
      },
    ],
  },
  {
    id: 16,
    title: "1998",
    data: [
      {
        month: "Agosto",
        detail: "Comienzo de la recesión económica.",
      },
    ],
  },
  {
    id: 17,
    title: "1999",
    data: [
      {
        month: "Julio",
        detail: "Entra en vigor el Acuerdo Marco de Cooperación MERCOSUR-Unión Europea.",
      },
      {
        month: "Septiembre",
        detail: "Creación del G 20. Argentina ingresa como miembro en calidad de país emergente.",
      },
      {
        month: "Octubre",
        detail: "Elecciones presidenciales: 1º) De la Rúa - Alvarez (Alianza UCR - FREPASO) 2º) Duhalde - Ortega (PJ) 3º) Cavallo - Caro Figueroa ( Acción por la República)",
      },
      {
        month: "Diciembre",
        detail: "Asume Fernando De la Rúa como presidente de la nación.",
      },
    ],
  },
  {
    id: 18,
    title: "2000",
    data: [
      {
        month: "Mayo",
        detail: "Ley de Reforma Laboral (Ley Banelco).",
      },
      {
        month: "Octubre",
        detail: "Renuncia del vicepresidente Carlos Álvarez.",
      },
    ],
  },
  {
    id: 19,
    title: "2001",
    data: [
      {
        month: "Enero",
        detail: "Argentina ratifica el Estatuto de Roma de la Corte Penal Internacional.",
      },
      {
        month: "Marzo",
        detail: "Nombramiento de Ricardo López Murphy como ministro de economía, 15 días después de anunciar su programa renunció y se lo reemplazó por Domingo Felipe Cavallo.",
      },
      {
        month: "Octubre",
        detail: "Elecciones legislativas (derrota del oficialismo y triunfo del “voto bronca”, preludio del “que se vayan todos”) Se aplica la ley de cupo femenino para las candidaturas al Senado Nacional.",
      },
      {
        month: "Noviembre",
        detail: "Se realiza el Censo Nacional de Población.",
      },
      {
        month: "Diciembre de 2001",
        detail: "Corralito - Movilizaciones populares: “que se vayan todos”. Asambleas populares - Mercados del trueque.",
      },
      {
        month: "19 y 20 de diciembre",
        detail: "Cacerolazos, movilizaciones, estado de sitio y consigna: “Que se vayan todos”.",
      },
      {
        month: "20 de diciembre",
        detail: "Renuncia del Presidente Fernando de la Rúa",
      },
      {
        month: "21 de Diciembre",
        detail: "Asume el presidente provisional del Senado Ramón Puerta",
      },
      {
        month: "23 de diciembre",
        detail: "La Asamblea legislativa elige a Adolfo Rodríguez Saa como presidente",
      },
      {
        month: "28 de diciembre",
        detail: "Movilización popular masiva contra el nuevo gobierno",
      },
      {
        month: "29 de diciembre",
        detail: "Renuncia de Adolfo Rodríguez Saá.",
      },
      {
        month: "30 de diciembre",
        detail: "Asume el presidente de la Cámara de Diputados Eduardo Camaño.",
      },
    ],
  },
  {
    id: 20,
    title: "2002",
    data: [
      {
        month: "Enero",
        detail: "1º de enero de la Asamblea Legislativa elige a Eduardo Duhalde como presidente.",
      },
      {
        month: "",
        detail: "Fin de la Convertibilidad Económica y pesificación de los depósitos bancarios en moneda extranjera",
      },
      {
        month: "Junio",
        detail: "Represión en la movilización de Puente Pueyrredón. Asesinan a los militantes sociales  Maximiliano Kosteki y Darío Santillán. Como consecuencia el gobierno nacional adelanta las elecciones que iban a ser en octubre de 2003, para abril de ese año.",
      },
    ],
  },
  {
    id: 21,
    title: "2003",
    data: [
      {
        month: "Abril",
        detail: "Primera vuelta electoral: Menem gana, pero no se presenta a  segunda vuelta. Triunfo de Néstor Kirchner.",
      },
      {
        month: "Mayo",
        detail:
          "Asume Néstor Kirchner ante la negativa de Menem de participar en el ballotage: Discurso de asunción con nuevas perspectivas en DDHH y en política Económica",
      },
      {
        month: "Junio",
        detail:
          "Inicio de renovación de la Corte Suprema de Justicia de la Nación.",
      },
      {
        month: "Agosto",
        detail:
          "Derogación de las leyes de obediencia debida y punto final.",
      },
      {
        month: "",
        detail:
          "La Corte Suprema de Justicia de la Nación declara inconstitucionales los indultos.",
      },
      {
        month: "",
        detail: "Comienzo de los juicios por delitos de Lesa Humanidad.",
      },
    ],
  },
  {
    id: 22,
    title: "2004",
    data: [
      {
        month: "Marzo",
        detail: "Derogación de la ley de reforma laboral del 2000.",
      },
      {
        month: "",
        detail: "Se firma el Acta de Copacabana entre Argentina y Brasil con el objetivo de crear la Comunidad Sudamericana de Naciones y trabajar para alcanzar un acuerdo birregional entre Mercosur y la Unión Europea.",
      },
      {
        month: "Abril",
        detail: "Secuestro y asesinato de Axel Blumberg. Leyes Blumberg (reformas al Código Penal con endurecimiento de las penas tras dos movilizaciones multitudinaria frente al Congreso Nacional.",
      },
      {
        month: "Noviembre",
        detail: "3º Congreso Internacional de la Lengua Española en Rosario",
      },
      {
        month: "Diciembre",
        detail: "Incendio en la discoteca Cromañón: 194 muertos",
      },
    ],
  },
  {
    id: 23,
    title: "2005",
    data: [
      {
        month: "Octubre",
        detail: "Elecciones legislativas para Diputados y Senadores nacionales. ",
      },
      {
        month: "Noviembre",
        detail:
          "Se celebra en Mar del Plata la 4º Cumbre de las Américas en la cual se rechazó la creación del Área de Libre Comercio de las Américas, conocido como el “No al ALCA”.",
      },
      {
        month: "Diciembre",
        detail:
          "Argentina anuncia la cancelación anticipada de la totalidad de la deuda con el FMI por aproximadamente 9.500 millones de dólares.",
      },
    ],
  },
  {
    id: 24,
    title: "2006",
    data: [
      {
        month: "Marzo",
        detail: "Destitución del Intendente de Capital Federal, Aníbal Ibarra, sometido a Juicio Político por la tragedia de Cromañón en diciembre de 2004.",
      },
      {
        month: "Septiembre",
        detail:
          "Desaparición de Jorge Julio Lopez.",
      },
      {
        month: "Diciembre",
        detail:
          "Ley de educación nacional que deroga la ley Federal de Educación y establece la obligatoriedad del ciclo secundario.",
      },
    ],
  },
  {
    id: 25,
    title: "2007",
    data: [
      {
        month: "Enero",
        detail: "El riesgo país cae a 186, uno de los valores más bajos de la historia.",
      },
      {
        month: "Marzo",
        detail:
          "Declaran a la Argentina País Libre de Aftosa. ",
      },
      {
        month: "Mayo",
        detail: "El índice de desocupación cae al 8,3%, el más bajo de los últimos 20 años.",
      },
      {
        month: "Octubre",
        detail: "Elecciones Presidenciales. Asume Cristina Fernández como presidenta de la nación. Es la primera mujer en asumir este cargo.",
      },
    ],
  },
  {
    id: 26,
    title: "2008",
    data: [
      {
        month: "Marzo",
        detail: "Incremento del impuesto a los derechos de exportación del trigo, el maíz y la soja, llamadas “retenciones al agro” vía Resolución 125.",
      },
      {
        month: "Marzo a Julio",
        detail:
          "Paro y movilización de las entidades agropecuarias en protesta por el aumento de las denominadas “retenciones” a la exportación de granos.",
      },
      {
        month: "Mayo",
        detail: "Argentina firma el tratado de creación de la Unión Suramericana de Naciones (UNASUR) en Brasilia.",
      },
      {
        month: "Julio",
        detail: "Votación en el senado por la Resolución 125: empate que desempató el Vicepresidente Julio Cobos. Inicio de la llamada “grieta”.",
      },
      {
        month: "Agosto",
        detail: "Se aprueba en el congreso la re-estatización de Aerolíneas Argentinas.",
      },
      {
        month: "Octubre",
        detail: "Re-estatización de los fondos de jubilaciones y pensiones.",
      },
    ],
  },
  {
    id: 27,
    title: "2009",
    data: [
      {
        month: "Marzo",
        detail: "Muerte de Raúl Alfonsín 31 de marzo.",
      },
      {
        month: "Octubre",
        detail: "Aprobación de la Ley de servicios de comunicación audiovisual.",
      },
      {
        month: "",
        detail: "Decreto de aprobación de la Asignación universal por hijo (AUH).",
      },
      {
        month: "",
        detail: "Fallecimiento de Mercedes Sosa.",
      },
      {
        month: "Diciembre",
        detail: "Ley de Democratización de la Representación política, la Transparencia y la Equidad Electoral, la que establece las elecciones Primarias Abiertas Simultáneas y Obligatorias (PASO).",
      },
    ],
  },
  {
    id: 28,
    title: "2010",
    data: [
      {
        month: "Abril",
        detail: "La Corte Internacional de Justicia finalizó la controversia entre Argentina y Uruguay por la instalación de plantas de celulosa a orillas del río Uruguay conocida como “el conflicto de las papeleras” iniciado en 2003.",
      },
      {
        month: "Mayo",
        detail:
          "Festejos del Bicentenario de la Revolución de Mayo.",
      },
      {
        month: "Julio",
        detail: "Ley de Matrimonio Igualitario.",
      },
      {
        month: "Octubre",
        detail: "Asesinato de Mariano Ferreyra. ",
      },
      {
        month: "",
        detail: "Muerte de Néstor Kirchner.",
      },
      {
        month: "",
        detail: "Se realiza el Censo Nacional de Población.",
      },
    ],
  },
  {
    id: 29,
    title: "2011",
    data: [
      {
        month: "Enero",
        detail: "Argentina asume la presidencia anual del G-77+China, grupo que reúne a 131 países más China y representa a más de un tercio del total de los miembros de la ONU.",
      },
      {
        month: "Marzo",
        detail: "Entra en vigencia la UNASUR.",
      },
      {
        month: "",
        detail: "Argentina participa en la creación de la Comunidad de Estados Latinoamericanos y Caribeños (CELAC).",
      },
      {
        month: "Diciembre",
        detail: "2° presidencia de Cristina Fernández.",
      },
    ],
  },
  {
    id: 30,
    title: "2012",
    data: [
      {
        month: "Febrero",
        detail: "“Tragedia de 11”, murieron 50 personas y hubo 676 heridos.",
      },
      {
        month: "Abril",
        detail:
          "Re-estatización parcial de YPF S.A.",
      },
      {
        month: "Mayo",
        detail:
          "Ley de Identidad de Género.",
      },
      {
        month: "2012-2013",
        detail:
          "Protestas de la clase media urbana entre mayo de 2012 y agosto 2013 donde hubo tres convocatorias relevantes, las movilizaciones del “13S” (13/9/2012), del “8N” (8/11/2012) y del (18A) (18/4/2013)",
      },
    ],
  },
  {
    id: 31,
    title: "2013",
    data: [
      {
        month: "Marzo",
        detail: "Jorge Bergoglio es elegido Papa, el primero no europeo de la historia de la Iglesia Católica.",
      },
      {
        month: "Agosto",
        detail: "Argentina asume la presidencia del Consejo de Seguridad de la ONU tras ser electa como miembro no permanente para el período 2013-2014 por la Asamblea General de la ONU con el apoyo de los países latinoamericanos.",
      },
      {
        month: "",
        detail: "Explosión de calle Salta en Rosario por fuga de gas.",
      },
      {
        month: "Octubre",
        detail: "Elecciones legislativas para Diputados y Senadores nacionales.",
      },
    ],
  },
  {
    id: 32,
    title: "2014",
    data: [
      {
        month: "Octubre",
        detail: "Asesinato de Franco Casco. Caso de violencia institucional. ",
      },
      {
        month: "",
        detail:
          "Lanzamiento del primer satélite de comunicaciones de Latinoamérica, ArSat-1, concretado por INVAP.",
      },
      {
        month: "Noviembre",
        detail:
          "Violencia policial en Rosario: aparición sin vida del cuerpo de Franco Casco)",
      },
    ],
  },
  {
    id: 33,
    title: "2015",
    data: [
      {
        month: "Junio",
        detail: "Marcha “Ni una Menos” Paro Internacional de Mujeres",
      },
      {
        month: "Agosto",
        detail: "Entra en vigencia el nuevo Código Civil y Comercial.",
      },
      {
        month: "Diciembre",
        detail: "Argentina participa de la COP21 de París donde las Partes de la Convención Marco de las Naciones Unidas sobre el Cambio Climático.",
      },
      {
        month: "",
        detail: "Asume como presidente Mauricio Macri (2015-2019).",
      },
      {
        month: "",
        detail: "Levantamiento del Cepo Cambiario.",
      },
      {
        month: "",
        detail: "Eliminación de los derechos de exportación (llamados “retenciones”) del trigo, maíz, carne y productos regionales, y reducción para la soja del 5%).",
      },
    ],
  },
  {
    id: 34,
    title: "2016",
    data: [
      {
        month: "Enero",
        detail: "Detención de la dirigente social Milagro Sala en Jujuy.",
      },
      {
        month: "Febrero",
        detail:
          "Acuerdo con acreedores de holdouts y vuelta al mercado de deuda privada internacional",
      },
      {
        month: "Marzo",
        detail: "Suspensión de la construcción del satélite ArSat-3",
      },
    ],
  },
  {
    id: 35,
    title: "2017",
    data: [
      {
        month: "Agosto",
        detail: "Corte de ruta por la comunidad mapuche en la provincia de Chubut.",
      },
      {
        month: "Octubre",
        detail:
          "Aparición sin vida de Santiago Maldonado.",
      },
      {
        month: "",
        detail: "Elecciones legislativas de medio término. Triunfo de la coalición gobernante.",
      },
      {
        month: "Noviembre",
        detail: "Represión y muerte por parte del grupo de Albatros de Prefectura de Rafael Nahuel.",
      },
      {
        month: "Diciembre",
        detail: "El policía Luis Chocobar mata por la espalda a un delincuente. En mayo de 2021 Luis Chocobar fue sentenciado por “homicidio con exceso en cumplimiento del deber” a dos años de prisión y cinco años de inhabilitación para funciones operativas.",
      },
    ],
  },
  {
    id: 36,
    title: "2018",
    data: [
      {
        month: "Enero",
        detail: "La Ley de Emergencia Económica deja de estar en vigencia, luego de 27 años.",
      },
      {
        month: "Mayo",
        detail: "Mauricio Macri solicita préstamo al FMI por 55 mil millones de dólares.",
      },
      {
        month: "Noviembre",
        detail: "Se celebra la XII Cumbre del G-20 en Argentina.",
      },
    ],
  },
  {
    id: 37,
    title: "2019",
    data: [
      {
        month: "Enero",
        detail: "Jair Bolsonaro y Mauricio Macri se reunieron en Brasilia.",
      },
      {
        month: "Marzo",
        detail: "Se realiza en Argentina la Segunda Conferencia de Alto Nivel de las Naciones Unidas sobre la Cooperación Sur-Sur (PABA+40).",
      },
      {
        month: "Abril",
        detail: "Argentina anuncia su salida de la UNASUR.",
      },
      {
        month: "Junio",
        detail: "Histórico apagón de energía eléctrica. El suministro de electricidad afectó a todo el país.",
      },
      {
        month: "Diciembre",
        detail: "Asume como presidente Alberto Fernández.",
      },
      {
        month: "",
        detail: "El Ministro de Salud Ginés González anunció un nuevo protocolo para el aborto no punible.",
      },
    ],
  },
  {
    id: 38,
    title: "2020",
    data: [
      {
        month: "Marzo",
        detail: "Argentina confirma el primer caso de coronavirus Covid-19.",
      },
      {
        month: "",
        detail: "Se decreta el Aislamiento Social Preventivo y Obligatorio.",
      },
      {
        month: "Octubre",
        detail: "Se presenta la Vacuna contra el COVID-19 ARVAC Cecilia Grierson (integralmente argentina). Hasta 2023 la misma sigue en desarrollo en una etapa de ensayos masivos para humanos.",
      },
      {
        month: "Noviembre",
        detail: "Fallecimiento de Diego Armando Maradona.",
      },
      {
        month: "Diciembre",
        detail: "Aprobación de la Ley de Interrupción voluntaria del embarazo",
      },
    ],
  },
  {
    id: 39,
    title: "2021",
    data: [
      {
        month: "Febrero",
        detail: "Fallecimiento del ex presidente Carlos Saúl Menem.",
      },
      {
        month: "",
        detail: "Aprobación de la Ley de Financiamiento del Sistema Nacional de Ciencia, Tecnología e Innovación.",
      },
      {
        month: "Julio",
        detail: "La selección argentina de fútbol masculino se consagra campeón de la Copa América.",
      },
      {
        month: "Octubre",
        detail: "Homenaje a Charly García por sus 70 años en el Teatro Colón.",
      },
    ],
  },
  {
    id: 40,
    title: "2022",
    data: [
      {
        month: "Febrero",
        detail: "Argentina se incorpora a la Franja y la Ruta de la Seda de China.",
      },
      {
        month: "Marzo",
        detail:
          "Acuerdo con el Fondo Monetario Internacional (FMI) para reestructurar su deuda de 45 mil millones de dólares.",
      },
      {
        month: "Septiembre",
        detail: "Estreno de la película “Argentina, 1985”, rememorando el Juicio a la Junta de Comandantes.",
      },
      {
        month: "Diciembre",
        detail: "La Selección Argentina de fútbol masculino se consagra Tri Campeón Mundial de Fútbol.",
      },
    ],
  },
  {
    id: 41,
    title: "2023",
    data: [
      {
        month: "Agosto",
        detail: "Argentina es admitida como miembro por el grupo Brasil, Rusia, China y Sudáfrica (Bric's).",
      },
      {
        month: "",
        detail:
          "Realización de las elecciones Primarias Abiertas, Simultáneas y Obligatorias para la renovación de autoridades nacionales.",
      },
      {
        month: "Octubre",
        detail: "Elecciones presidenciales, pasan a balotaje los candidatos presidenciales de Unión por Todos (Sergio Massa) y La Libertad Avanza (Javier Milei).",
      },
      {
        month: "Noviembre",
        detail: "El candidato de La Libertad Avanza, Javier Milei, es elegido, en instancia de balotaje, presidente de la nación con el 56% de los votos.",
      },
      {
        month: "Diciembre",
        detail: "“40 años ininterrumpidos de democracia”.",
      },
    ],
  },
];
